import React, { FC } from 'react'
import { isMobile } from 'react-device-detect'

import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericMainCard from '../../../GenericComponents/GenericMainCard'

import GenericButton from '../../../GenericComponents/GenericButton'

import GenericInput from '../../../GenericComponents/GenericInput'

interface EnterChatNameInterface {
  handleJoinChatButtonClick: Function
  handleChatEditNameInput: Function
  chatName: string
}

const EnterChatName: FC<EnterChatNameInterface> = ({
  handleChatEditNameInput,
  handleJoinChatButtonClick,
  chatName,
}) => {
  return (
    <GenericMainCard
      className={'standard'}
      margin={isMobile ? '0 0 0 0' : '0 0 0 20%'}
      width={isMobile ? '90%' : '50%'}
      flexDir={'column'}
    >
      <GenericTextSpan fSize={'1.3rem'}>Chat Box</GenericTextSpan>
      <GenericInput
        onChange={(e: any) => handleChatEditNameInput(e.target.value)}
        margin={'10% 0'}
        autoFocus
        active
        fSize={'2.5rem'}
        value={chatName ? chatName : ''}
        className={'no-border color-white font-big-always text-center'}
      ></GenericInput>
      <GenericButton
        onClick={() => handleJoinChatButtonClick()}
        width={isMobile ? '90%' : '70%'}
        justify={'center'}
        className={'standard'}
      >
        Dołącz
      </GenericButton>
    </GenericMainCard>
  )
}

export default EnterChatName
